// extracted by mini-css-extract-plugin
export var container = "_ej-1";
export var cornerButtonContainer = "_ej-6";
export var disabled = "_ej-2";
export var dragActive = "_ej-3";
export var fileContainer = "_ej-5";
export var hiddenInput = "_ej-4";
export var widthContainer = "_ej-0";